import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import { createStore } from 'vuex-extensions';

// Modules
import fullscreenModal from '@/store/modules/fullscreenModal';
import grid from '@/store/modules/grid';
import modal from '@/store/modules/modal';
import notification from '@/store/modules/notification';
import pending from '@/store/modules/pending';
import system from '@/store/modules/system';
import user from '@/store/modules/user';
import series from '@/store/modules/series';

const modules = {
  fullscreenModal,
  grid,
  modal,
  notification,
  pending,
  system,
  user,
  series,
};

const vuexLocalStorage = new VuexPersist({
  key: 'vuex',
  storage: window.localStorage,
  reducer: (state) => ({
    user: state.user,
    system: state.system,
    grid: state.grid,
    series: state.series,
  }),
});

Vue.use(Vuex);

export default createStore(Vuex.Store, {
  // throw an error if an attempt is made to mutate the store directly
  // https://vuex.vuejs.org/en/strict.html#development-vs-production
  strict: process.env.NODE_ENV !== 'production',
  // compose API modules
  modules,
  plugins: [vuexLocalStorage.plugin],
});
